import { CircleAlert, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { Typography } from '@/components/ui/typography';
import { integrationStatusCopy as copy } from './copy';

interface Props { open: boolean; vendorName: string; isConfirming: boolean; onConfirm: () => void; onCancel: () => void }

export const DisableIntegrationDialog = ({ open, vendorName, isConfirming, onConfirm, onCancel }: Props) => (
  <Modal
    open={open}
    onOpenChange={(next) => { if (!next && !isConfirming) onCancel(); }}
    title={copy.dialog.title(vendorName)}
    size="md"
    footer={
      <>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isConfirming} className="w-full sm:w-auto">{copy.dialog.cancel}</Button>
        <Button type="button" variant="destructive" onClick={onConfirm} disabled={isConfirming} className="w-full sm:w-auto">
          {isConfirming && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
          {isConfirming ? copy.dialog.confirming : copy.dialog.confirm}
        </Button>
      </>
    }
  >
    <div className="flex flex-col gap-4">
      <ul className="flex flex-col gap-3 rounded-md bg-muted p-4">
        {copy.dialog.bullets(vendorName).map((bullet) => (
          <li key={bullet} className="flex items-start gap-3">
            <CircleAlert className="mt-0.5 h-[18px] w-[18px] shrink-0 text-warning" aria-hidden="true" />
            <Typography variant="body">{bullet}</Typography>
          </li>
        ))}
      </ul>
      <Typography variant="body" className="text-muted-foreground">{copy.dialog.reassurance(vendorName)}</Typography>
    </div>
  </Modal>
);
